function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.78571 18.7143L7.0238 13.4762L10.1667 16.6191L17.5 9.28575L22.2143 14",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 1.75,
  y: 3.75,
  width: 20.5,
  height: 17.3571,
  rx: 2.25,
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.5,
  cy: 8.50003,
  r: 1.60714,
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgImage = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgImage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Image.d03b780a.svg";
export { ForwardRef as ReactComponent };